module.exports = __webpack_public_path__ + "static/media/exh2.95366d32.png";